<app-loader *ngIf="isDisabled"></app-loader>

<div class="card">
    <div class="card-header">
        <label>Employee wise summary for <span class="fw-bold">({{this.SiteName}})</span></label>
    </div>
    <div class="card-body">
        <form class="g-3" name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="row">
                <div class="col-md-3" *ngIf="this.Filter.DDEdit">
                    <ng-select [items]="Designations" name="Designations" bindLabel="DesignationName"
                        bindValue="DesignationMasterID" placeholder="Select Designation"
                        [(ngModel)]="Filter.DesignationMasterID" [virtualScroll]="true"
                        (change)="ComboLoadAsync('Duty',-1)" [disabled]="!this.Filter.DDEdit" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select designation.
                    </div>
                </div>
                <div class="col-md-2" *ngIf="this.Filter.DDEdit">
                    <ng-select [items]="Dutys" name="Dutys" bindLabel="DutyName" bindValue="DutyMasterID"
                        placeholder="Select Duty" [(ngModel)]="Filter.DutyMasterID" [virtualScroll]="true"
                        (change)="ComboLoadAsync('ShiftLoadBasedOnDesignationDuty',-1)" [disabled]="!this.Filter.DDEdit"
                        required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select duty.
                    </div>
                </div>
                <div class="col-md-2" *ngIf="this.Filter.DDEdit">
                    <ng-select [items]="Shifts" name="Shifts" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="Select Shift" [(ngModel)]="Filter.ShiftMasterID" [virtualScroll]="true"
                        [disabled]="!this.Filter.DDEdit" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select shift.
                    </div>
                </div>
                <div class="col-md-2" *ngIf="this.Filter.DDEdit">
                    <button class="btn btn-primary" type="submit" [disabled]="isDisabled"><i class="bi bi-funnel me-2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Applying...'}}
                    </button>
                </div>
                <div class="col">
                    <div class="Stick-Header">
                        <div
                            style="height: 3rem;min-width:15rem; width: fit-content;justify-self:center;color:white;background:var(--success);align-content:center">
                            <div class="row no-gutters cursor-pointer text-start align-items-center px-2" >
                                <div class="col-auto p-2" (click)="changeEmp(-1)" *ngIf="!this.Filter.DDEdit">
                                    <i class="bi bi-chevron-left"></i>
                                </div>
                                <div class="col-2 p-2">
                                    <img *ngIf="this.tableData[this.Index].Photo" mat-card-image class="userImage"
                                        [src]="this.common.PhotoLink(this.tableData[this.Index].Photo,false)"
                                        style="width: 30px;height: 30px;" />

                                    <div *ngIf="!this.tableData[this.Index].Photo" class="initial-image"
                                        data-is-profile="true" style="width: 30px;height: 30px;">
                                        <div class="image" style="line-height:30px">
                                            {{this.common.getInitial(this.tableData[this.Index].FullName)}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col userdetail p-0">
                                    <span class="text-label"
                                        style="font-size: small !important;">{{this.tableData[this.Index].FullName}}</span><br />
                                    <span class="text-label-light"
                                        style="font-size: x-small !important;">#{{this.tableData[this.Index].EmpCode}}/{{this.tableData[this.Index].Gender}}</span>
                                </div>
                                <div class="col-auto p-2" (click)="changeEmp(1)" *ngIf="!this.Filter.DDEdit">
                                    <i class="bi bi-chevron-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-2" *ngIf="!this.Filter.DDEdit && !this.IsLocked && this.CompanyPermiter.IsUpdateDesignationDutyAllowed && this.common.PageRight.IsEdit">
                <label class="Label fw-bold">
                    <input type="checkbox" name="sezcustomer" (change)="checkboxChanged()"
                        [(ngModel)]="this.Filter.DDEdit" ngbCheckbox />
                    Enable Designation Duty <small class="text-muted">(Note : If Enable desigantion duty all changes
                        reset)</small>
                </label>
            </div>
        </form>
    </div>
    <form name="EmpSummaryForm" (ngSubmit)="Validate(EmpSummaryForm)" #EmpSummaryForm="ngForm">
        <div class="card-body">
            <div class="row">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="summarydata"
                    class="customeDatatable table table-bordered" name="summarydata"
                    style="font-size: xx-small !important">
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="close()"
                        [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit" class="btn btn-sm btn-primary" [disabled]="isDisabled" *ngIf="this.common.PageRight.IsEdit"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </form>
</div>